/** Lumira: contador visual de 10 minutos. No reserva inventario. */
const DURATION = 10 * 60 * 1000;
const STORAGE_KEY = 'lumira_cart_timer_10m_v2';
const SELECTOR = '[data-cart-reservation-timer]';
let memoryEnd = null;
let interval = null;
let observedDrawer = null;
let observer = null;
let scheduled = false;

function readEnd() {
  try {
    const value = Number(localStorage.getItem(STORAGE_KEY));
    if (Number.isFinite(value) && value > 0) return value;
  } catch { /* Safari privado o almacenamiento desactivado: usar memoria. */ }
  return memoryEnd;
}

function getEnd() {
  const stored = readEnd();
  // Conservar también una fecha caducada: recargar no reinicia la cuenta.
  if (stored !== null) return (memoryEnd = stored);
  memoryEnd = Date.now() + DURATION;
  try { localStorage.setItem(STORAGE_KEY, String(memoryEnd)); } catch { /* Usar memoria. */ }
  return memoryEnd;
}

function stop() {
  if (interval !== null) window.clearInterval(interval);
  interval = null;
}

function reset() {
  stop();
  memoryEnd = null;
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* Usar memoria. */ }
}

function render(end) {
  const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
  const text = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
  observedDrawer?.querySelectorAll(SELECTOR).forEach((element) => {
    if (element.textContent !== text) element.textContent = text;
    element.setAttribute('aria-label', seconds ? `Tiempo restante: ${text}` : 'Cuenta finalizada. Puedes continuar con tu compra.');
  });
  return seconds > 0;
}

function synchronize() {
  stop();
  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) return;
  observedDrawer = drawer;
  const count = drawer.querySelector('[ref="cartItemCount"]');
  if (drawer.querySelector('.cart-drawer--empty') || (count && Number(count.textContent.trim()) === 0)) {
    reset();
    return;
  }
  if (!drawer.querySelector(SELECTOR)) return;
  const end = getEnd();
  if (render(end)) {
    interval = window.setInterval(() => {
      if (!observedDrawer?.isConnected || !observedDrawer.querySelector(SELECTOR)) {
        synchronize();
      } else if (!render(end)) {
        stop();
      }
    }, 1000);
  }
}

function scheduleSync() {
  if (scheduled) return;
  scheduled = true;
  queueMicrotask(() => {
    scheduled = false;
    synchronize();
  });
}

function initialize() {
  const drawer = document.querySelector('#cart-drawer');
  if (drawer !== observedDrawer) {
    observer?.disconnect();
    observedDrawer = drawer;
    if (drawer) {
      observer = new MutationObserver((mutations) => {
        // Ignorar las escrituras del propio contador para evitar bucles.
        const relevant = mutations.some((mutation) => {
          const element = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
          return !element?.closest(SELECTOR);
        });
        if (relevant) scheduleSync();
      });
      observer.observe(drawer, { childList: true, characterData: true, subtree: true });
    }
  }
  synchronize();
}

document.addEventListener('visibilitychange', () => { if (!document.hidden) initialize(); });
document.addEventListener('shopify:section:load', initialize);
window.addEventListener('pageshow', initialize);
window.addEventListener('storage', (event) => {
  if (event.key === STORAGE_KEY || event.key === null) {
    memoryEnd = null;
    initialize();
  }
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
} else {
  initialize();
}

// Safari móvil: usar la altura realmente visible sobre las barras del navegador.
function updateLumiraViewport() {
  const drawer = document.querySelector('#cart-drawer');
  const viewport = window.visualViewport;
  if (!drawer || (viewport && viewport.scale !== 1)) return;
  const height = Math.round(viewport?.height || window.innerHeight);
  if (height > 0) drawer.style.setProperty('--lumira-viewport-height', `${height}px`);
}
window.addEventListener('resize', updateLumiraViewport, {passive:true});
window.visualViewport?.addEventListener('resize', updateLumiraViewport, {passive:true});
window.addEventListener('pageshow', updateLumiraViewport);
document.addEventListener('shopify:section:load', updateLumiraViewport);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLumiraViewport, {once:true});
else updateLumiraViewport();
